<template>
  <div class="fairUseDetails">
    <span>Here is what you need to know:</span>
    <ul>
      <li>The feature is not included in your current plan.</li>
      <li :data-test-id="$testId('endDateText')">
        Your 30-day period {{ verb }} on
        <strong class="date">{{ endDate.format('MMM DD, YYYY') }}</strong>.
        Learn to opt out in
        <Link
          :data-test-id="$testId('stopTrialLink')"
          :href="StopTrialKBLink.url"
          :isMatchText="false"
          target="_blank"
          text="Stop a Trial"
          @click.native="handleStopTrialLinkClick"
        />.
      </li>
      <li :data-test-id="$testId('recommendedPackageText')">
        To purchase <strong>{{ featureName }}</strong>,
        view our <Link
          :data-test-id="$testId('pricingLink')"
          :href="pricingLink"
          :isExternal="!hasBilling"
          :isMatchText="false"
          :target="hasBilling ? '_parent' : '_blank'"
          text="pricing"
          @click.native="handlePricingLinkClick"
        /> here.
      </li>
    </ul>
  </div>
</template>

<script>
import { Link } from '@jumpcloud/ui-components';
import { UiEvents } from '@jumpcloud/ui-events-vue';
import { mapGetters } from 'vuex';
import moment from 'moment';

import { ItemTypeConsts, ItemTypeRoutes } from 'client/util/Constants';
import { trialModalLinks } from 'client/util/Constants/FeatureTrialConstants';

export default {
  name: 'FairUseDetails',

  components: {
    Link,
  },

  props: {
    endDate: {
      type: Object,
      default: () => moment(),
    },
    featureName: {
      type: String,
      default: () => '',
    },
    isAddOn: Boolean,
    recommendationPackageName: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    ...mapGetters('SettingsModule', {
      hasBilling: 'hasBilling',
    }),

    packageType() {
      return this.isAddOn ? 'add-on' : 'plan';
    },

    pricingLink() {
      return this.hasBilling
        ? ItemTypeRoutes[ItemTypeConsts.accountUpgrade]
        : trialModalLinks.pricing.externalLink;
    },

    verb() {
      return this.endDate.diff(moment(), 'days') < 0
        ? 'ended'
        : 'ends';
    },
  },

  created() {
    this.StopTrialKBLink = trialModalLinks.stopATrial;
  },

  methods: {
    handlePricingLinkClick() {
      const pageLinkName = this.hasBilling
        ? 'Upgrade Page'
        : 'External Pricing Page';

      UiEvents.triggerLinkClicked({
        description: `${pageLinkName} link clicked`,
        section: 'footer',
        page: `${this.featureName} Trial Modal`,
        text: 'pricing',
      });

      if (this.hasBilling) this.$emit('close');
    },

    handleStopTrialLinkClick() {
      UiEvents.triggerLinkClicked({
        description: 'Stop A Trial link clicked',
        section: 'footer',
        page: `${this.featureName} Trial Modal`,
        text: 'Stop A Trial',
      });
    },
  },
};
</script>

<style scoped>
.date {
  font-style: italic;
}

.fairUseDetails {
  border: 1px solid var(--jcGrey300);
  border-radius: 10px;
  font-size: var(--jcBodyTiny);
  padding: var(--jc-spacer-small) var(--jc-spacer-large);
}

li {
  font-size: var(--jcBodyTiny);
  margin: var(--jc-spacer-small) 0;
}

ul {
  padding-left: var(--jc-spacer-small);
}
</style>
